import { Theme } from '@mui/material';


const Pagination = (theme: Theme) => {
  return {
  };
};

export default Pagination;
